module.exports = __webpack_public_path__ + "assets/img/本地化部署.832958b7.jpg";